import { render } from "./SwdPhoneInput.vue?vue&type=template&id=53eb8cea&scoped=true"
import script from "./SwdPhoneInput.vue?vue&type=script&lang=js"
export * from "./SwdPhoneInput.vue?vue&type=script&lang=js"

import "./SwdPhoneInput.vue?vue&type=style&index=0&id=53eb8cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eb8cea"]])

export default __exports__